export default __webpack_public_path__ + "static/media/reviewer_form.731ac38a.doc";